// 実績紹介ページ「ハイライト」のカルーセル。
// 対象HTML（.js-pickup-slider）が無いページでは何もしない。
//
// 先方要望（2026-09-16）：矢印をなくし、法人向けページ FV（.js-slider・data-hover無し）と
// 同じ動きにする。＝ループして自動で送るだけ。矢印もホバー停止も持たない。
// 送る間隔は先方指定の 2.5秒（修正リスト 行3）。
export function initPickupSlider () {
  const sliders = document.querySelectorAll('.js-pickup-slider');
  if (!sliders.length || typeof Swiper === 'undefined') return;

  sliders.forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 1.15,  // SP: 1枚 + 両端 peek（法人向けFVと同値）
      spaceBetween: 16,     // 1rem
      centeredSlides: true,
      loop: true,
      speed: 600,           // 切替アニメ 0.6秒
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      // カード全体が <a> なので、押下中に指やマウスが数px動いただけで
      // Swiper がドラッグと判定し preventClicks でリンク遷移が打ち消される。
      // 8px 未満の移動はドラッグとみなさず、クリックをそのまま通す。
      threshold: 8,
      a11y: {
        enabled: true,
      },
      breakpoints: {
        569: {
          slidesPerView: 2.4, // タブレット: 2枚 + peek
          spaceBetween: 24,   // 1.5rem
        },
        769: {
          slidesPerView: 4.2, // PC: 4枚 + 両端 peek
          spaceBetween: 32,   // 2rem
        },
      },
    });
  });
}
